<template>
  <div class="page-wrapper">
    <menu-dispatcher></menu-dispatcher>

    <div class="wrapper">
      <header-dispatcher></header-dispatcher>
      <div class="screen-container">
        <div class="center-content">
          <div class="content-box">
            <div class="content-head">
              <div class="title">
                <router-link to="/directories/downtime-categories">
                  <a class="back" title="Назад"><img src="../image/back.png"></a>
                </router-link>
                {{ isNew ? 'Добавить' : 'Редактировать' }}
              </div>
              <div class="cabinet-body"></div>
            </div>
            <div class="content-body directorys-page">
              <div class="cabinet-info">
                <div class="directory-box">
                  <div class="main-content">
                    <div class="head-panel visibility">
                      <span class="table-string-delete" v-show="!isNew" @click="remove"><i class="fa fa-trash-o"></i>Удалить строку</span>
                    </div>
                    <div class="form">
                      <div class="fieldset">
                        <label class="fieldset-title">Наименование категории</label>
                        <fieldset :class="{'fieldset-error': errors.has('name')}">
                          <input type="text" v-model="name"
                                 v-validate="'required'" :class="{'input': true}" name="name">
                          <span v-show="errors.has('name')" class="error-text">Заполните обязательное поле</span>
                        </fieldset>
                      </div>
                      <div class="fieldset">
                        <label class="fieldset-title">Стоимость суток (Казань), руб.</label>
                        <fieldset :class="{'fieldset-error': errors.has('priceKzn')}">
                          <input type="number" v-model="priceKzn"
                                 v-validate="'required'" :class="{'input': true}" name="priceKzn">
                          <span v-show="errors.has('priceKzn')" class="error-text">Заполните обязательное поле</span>
                        </fieldset>
                      </div>
                      <div class="fieldset">
                        <label class="fieldset-title">Стоимость суток (Другой город), руб.</label>
                        <fieldset :class="{'fieldset-error': errors.has('price')}">
                          <input type="number" v-model="price"
                                 v-validate="'required'" :class="{'input': true}" name="price">
                          <span v-show="errors.has('price')" class="error-text">Заполните обязательное поле</span>
                        </fieldset>
                      </div>
                      <div class="fieldset">
                        <label class="fieldset-title">Зар. плата (Казань), руб.</label>
                        <fieldset :class="{'fieldset-error': errors.has('salaryKzn')}">
                          <input type="number" v-model="salaryKzn"
                                 v-validate="'required'" :class="{'input': true}" name="salaryKzn">
                          <span v-show="errors.has('salaryKzn')" class="error-text">Заполните обязательное поле</span>
                        </fieldset>
                      </div>
                      <div class="fieldset">
                        <label class="fieldset-title">Зар. плата (Другой город), руб.</label>
                        <fieldset :class="{'fieldset-error': errors.has('salary')}">
                          <input type="number" v-model="salary"
                                 v-validate="'required'" :class="{'input': true}" name="salary">
                          <span v-show="errors.has('salary')" class="error-text">Заполните обязательное поле</span>
                        </fieldset>
                      </div>
                      <div class="cashless-block">
                        <div class="fieldset">
                          <div class="title">Надбавка за безнал</div>
                        </div>
                        <div class="fieldset">
                          <label class="fieldset-title">Надбавка: Стоимость суток (Казань), руб.</label>
                          <fieldset :class="{'fieldset-error': errors.has('priceKznSurchargeByCashless')}">
                            <input type="number" v-model="priceKznSurchargeByCashless"
                                   v-validate="'required'" :class="{'input': true}" name="priceKznSurchargeByCashless">
                            <span v-show="errors.has('priceKznSurchargeByCashless')" class="error-text">Заполните обязательное поле</span>
                          </fieldset>
                        </div>
                        <div class="fieldset">
                          <label class="fieldset-title">Надбавка: Стоимость суток (Другой город), руб.</label>
                          <fieldset :class="{'fieldset-error': errors.has('priceSurchargeByCashless')}">
                            <input type="number" v-model="priceSurchargeByCashless"
                                   v-validate="'required'" :class="{'input': true}" name="priceSurchargeByCashless">
                            <span v-show="errors.has('priceSurchargeByCashless')" class="error-text">Заполните обязательное поле</span>
                          </fieldset>
                        </div>
                      </div>
                      <div class="buttons">
                        <button type="button" class="save-button" @click="save">
                          Сохранить
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    import MenuDispatcher from '@/components/MenuDispatcher.vue'
    import HeaderDispatcher from '@/components/HeaderDispatcher.vue'
    import api from '@/api'
    import VeeValidate from 'vee-validate'

    export default {
  name: 'DowntimeCategory',
  components: {
    MenuDispatcher,
    HeaderDispatcher,
    VeeValidate
  },

  data () {
    return {
      id: null,
      isNew: false,
      downtimeCategory: {},
      newDowntimeCategory: {}
    }
  },

  computed: {
    name: {
      get () {
        return !this.isNew ? this.downtimeCategory.name : this.newDowntimeCategory.name
      },

      set (name) {
        !this.isNew ? this.downtimeCategory.name = name : this.newDowntimeCategory.name = name
      }
    },
    price: {
      get () {
        return !this.isNew ? this.downtimeCategory.price : this.newDowntimeCategory.price
      },

      set (price) {
        !this.isNew ? this.downtimeCategory.price = price : this.newDowntimeCategory.price = price
      }
    },
    priceKzn: {
      get () {
        return !this.isNew ? this.downtimeCategory.priceKzn : this.newDowntimeCategory.priceKzn
      },

      set (priceKzn) {
        !this.isNew ? this.downtimeCategory.priceKzn = priceKzn : this.newDowntimeCategory.priceKzn = priceKzn
      }
    },
    salary: {
      get () {
        return !this.isNew ? this.downtimeCategory.salary : this.newDowntimeCategory.salary
      },

      set (salary) {
        !this.isNew ? this.downtimeCategory.salary = salary : this.newDowntimeCategory.salary = salary
      }
    },
    salaryKzn: {
      get () {
        return !this.isNew ? this.downtimeCategory.salaryKzn : this.newDowntimeCategory.salaryKzn
      },

      set (salaryKzn) {
        !this.isNew ? this.downtimeCategory.salaryKzn = salaryKzn : this.newDowntimeCategory.salaryKzn = salaryKzn
      }
    },

    priceSurchargeByCashless: {
      get () {
        return !this.isNew ? this.downtimeCategory.priceSurchargeByCashless : this.newDowntimeCategory.priceSurchargeByCashless
      },

      set (priceSurchargeByCashless) {
        !this.isNew ? this.downtimeCategory.priceSurchargeByCashless = priceSurchargeByCashless
          : this.newDowntimeCategory.priceSurchargeByCashless = priceSurchargeByCashless
      }
    },

    priceKznSurchargeByCashless: {
      get () {
        return !this.isNew ? this.downtimeCategory.priceKznSurchargeByCashless : this.newDowntimeCategory.priceKznSurchargeByCashless
      },

      set (priceKznSurchargeByCashless) {
        !this.isNew ? this.downtimeCategory.priceKznSurchargeByCashless = priceKznSurchargeByCashless
          : this.newDowntimeCategory.priceKznSurchargeByCashless = priceKznSurchargeByCashless
      }
    }
  },

  // кнопки для создания/удаления категории отсутствуют, но функционал оставлен для создания новой категории через веб,
  // на случай, если в будущем такая надобность возникнет, например, для суперадмина
  mounted () {
    let body = document.getElementsByTagName('body')[0]
    body.classList.add('cabinet-page')

    this.id = this.$route.params.id
    if (this.id == 'new') {
      this.isNew = true
      this.newDowntimeCategory = {
        name: null,
        price: null,
        kmPrice: null,
        priceKzn: null,
        salary: null,
        salaryKzn: null,
        priceSurchargeByCashless: null,
        priceKznSurchargeByCashless: null
      }
    } else {
      api
        .getDowntimeCategoryById(this.id)
        .then(downtimeCategory => {
          if (downtimeCategory) {
            this.downtimeCategory = downtimeCategory
            this.isNew = false
          }
        })
    }
  },

  destroyed () {
    let body = document.getElementsByTagName('body')[0]
    body.classList.remove('cabinet-page')
  },

  methods: {
    remove () {
      this.downtimeCategory.removed = true
      this.save()
    },

    save () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.$store.getters.waitingApiRequestsCount != 0) { return }

          this.isNew
            ? api
              .createDowntimeCategory(this.newDowntimeCategory)
              .then(() => {
                this.$router.push('/directories/downtime-categories')
                alert('Сохранено')
              })
              .catch(err => alert(err))
            : api
              .updateDowntimeCategory(this.id, this.downtimeCategory)
              .then(() => {
                this.$router.push('/directories/downtime-categories')
                alert('Сохранено')
              })
              .catch(err => alert(err))
        }
      })
    }
  }
}
</script>
